<script>
import {delLocalItem, filterEmptyParams, getLocalItem, setLocalItem} from "@/untils/common";
import {medium_audioFileNotifyLib} from "@/lib/request";
import {ClientId} from "@/lib/cli";
import axios from 'axios';
import {Dialog} from "vant";
// import OSS from 'ali-oss';
// import {configAli} from '@/untils/common.js'; // 引入你的OSS配置文件
export default {
  name:'saleStatistic',
  data(){
    return{
      //
      SingleNameList: [
        {type:'0', name: '年度汇总'},
        {type:'1', name: '1月'},
        {type:'2', name: '2月'},
        {type:'3', name: '3月'},
        {type:'4', name: '4月'},
        {type:'5', name: '5月'},
        {type:'6', name: '6月'},
        {type:'7', name: '7月'},
        {type:'8', name: '8月'},
        {type:'9', name: '9月'},
        {type:'10', name: '10月'},
        {type:'11', name: '11月'},
        {type:'12', name: '12月'},
      ],
      showMaterialValueParams: {type:'0', name: '年度汇总'},
      showMaterialFlag: false,
      //
      showMaterialOfficialValueParams:{type:'0', name: '全区'},
      showMaterialOfficialFlag: false,
      OfficialSingleNameList: [
        {type:'0', name: '全区'},
        {type:'1', name: '拉萨'},
        {type:'2', name: '日喀则'},
        {type:'3', name: '昌都'},
        {type:'4', name: '林芝'},
        {type:'5', name: '山南'},
        {type:'6', name: '那曲'},
        {type:'7', name: '阿里'},
      ],
      //列表
      page1: 0,
      size1: 20,
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      listDataAll: [
        {
          "id": "871419819910496256",
          "name": "双色球",
          "allNumber": "3201",
          "allWera": "38%",
          "weraNumber": "1232",
          "count": "19.2%",
          "countWera": "341",
        },{
          "id": "871419819910496256",
          "name": "快乐8",
          "allNumber": "3201",
          "allWera": "38%",
          "weraNumber": "1232",
          "count": "19.2%",
          "countWera": "341",
        },{
          "id": "871419819910496256",
          "name": "3D",
          "allNumber": "3201",
          "allWera": "38%",
          "weraNumber": "1232",
          "count": "19.2%",
          "countWera": "341",
        },{
          "id": "871419819910496256",
          "name": "七乐彩",
          "allNumber": "3201",
          "allWera": "38%",
          "weraNumber": "1232",
          "count": "19.2%",
          "countWera": "341",
        },{
          "id": "871419819910496256",
          "name": "七乐彩",
          "allNumber": "3201",
          "allWera": "38%",
          "weraNumber": "1232",
          "count": "19.2%",
          "countWera": "341",
        },
      ],
    }
  },
  components: {

  },
  watch: {
    // 监控参数变化
    searchParams: {
      handler(newVal, oldVal) {
        // 添加变化检测逻辑
        const isNameChanged = newVal.name !== oldVal.name;
        const isTypesChanged = JSON.stringify(newVal.types) !== JSON.stringify(oldVal.types);
        if (isNameChanged || isTypesChanged) {
          this.page1 = 0;
        }
        this.getListData();
      },
      deep: true,
      // immediate: false // 设为 false 避免初始化执行
    },
  },
  computed: {
    // 监控参数变化
    searchParams() {
      return {
        networkId: this.siteId,//网点编号
        name: this.searchInput,//按名称搜索
        page: this.page1,//页数
        size: this.size1,//条数
        types: this.typeTabIndex !== 1 ? (this.showMaterialOfficialValueParams.type?this.showMaterialOfficialValueParams.type:[...this.typeTab[this.typeTabIndex].typeList]) : this.showMaterialValueParams.type, // 类型数组
        usageType: this.typeTabIndex !== 1 ? 'General' : 'Personal',//素材使用类型['Personal-个人','General-通用']
        reviewStatus: this.typeTabIndex !== 1 ? '' : this.showReviewValueParams.type,//素材审核状态[待审核Pending,审核通过Pass,审核未通过Failed]
      };
    },
  },
  methods: {
    /*
    * 屏保配置
    * 素材查询列表和素材自定义播放配置操作
    * */
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    getListData() {
      this.tabFind = false;
      this.loading1 = true;
      this.finished1 = false;
      if (this.searchParams.page1 === 0) {
        this.listDataAll = [];
      }
      console.log(filterEmptyParams(this.searchParams))
      return false;
      this.$http.medium_marketingMaterialsFindByNetwork(filterEmptyParams(this.searchParams)).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.loading1 = false;
            if (res.data) {
              this.tabFind = true;
              let resData = res.data.rows;
              this.totals1 = res.data.totalRows;
              this.totalPages1 = Math.ceil(res.data.totalRows / this.size1) - 1;
              if (resData == null || resData.length === 0) {
                this.finished1 = true;
                this.listDataAll = [];
                return false;
              } else {
                resData.map((v) => {
                  v.checked = v.enabled;// enabled:ture已发布，false未发布
                  // 如果自定义的配置项列表有，则默认素材列表的项也是开状态
                  this.playData.map((i) => {
                    if (v.id === i.id && i.checked) {
                      v.checked = true;
                      v.typical = i.typical;
                    }
                  });
                  v.value = '';
                });
                if (this.page1 > 0) {
                  this.listDataAll = this.listDataAll.concat(resData);
                } else {
                  this.listDataAll = resData;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            } else {
              this.tabFind = true;
              this.$toast.fail('data无数据！');
            }
          } else {
            this.tabFind = true;
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    // 官方素材
    onMaterialOfficialType(value) {
      this.showMaterialOfficialValueParams = value;
      this.showMaterialOfficialFlag = false;
    },
    //素材类型 Material Type
    onMaterialType(value) {
      this.showMaterialValueParams = value;
      this.showMaterialFlag = false;
    },



  },
  created() {


  }
}
</script>
<template>
  <div class="wrap">
    <!-- 筛选时间 -->
    <van-popup v-model="showMaterialFlag" position="bottom">
      <van-picker
          show-toolbar
          title="选择时间"
          :columns="SingleNameList"
          value-key="name"
          @confirm="onMaterialType"
          @cancel="showMaterialFlag = false"
      />
    </van-popup>
    <!-- 筛选区域 -->
    <van-popup v-model="showMaterialOfficialFlag" position="bottom">
      <van-picker
          show-toolbar
          title="选择区域"
          :columns="OfficialSingleNameList"
          value-key="name"
          @confirm="onMaterialOfficialType"
          @cancel="showMaterialOfficialFlag = false"
      />
    </van-popup>
    <!--  主体内容布局开始  -->
    <div class="tab-content">
      <div class="card">
        <div class="filter-section">
            <div class="filter-row">
              <div class="filter-group">
                <label class="filter-label">选择时间</label>
                <van-field
                    v-model="showMaterialValueParams.name"
                    name=""
                    label=""
                    readonly="readonly"
                    placeholder="请选择时间"
                    @click="showMaterialFlag=true"
                >
                  <template #right-icon>
                    <van-icon name="arrow-down"/>
                  </template>
                </van-field>
              </div>
              <div class="filter-group">
                <label class="filter-label">选择区域</label>
                <van-field
                    v-model="showMaterialOfficialValueParams.name"
                    name=""
                    label=""
                    readonly="readonly"
                    placeholder="请选择区域"
                    @click="showMaterialOfficialFlag=true"
                >
                  <template #right-icon>
                    <van-icon name="arrow-down"/>
                  </template>
                </van-field>
              </div>
            </div>
          </div>
      </div>
      <div class="card">
        <div class="list-group" v-for="(item,index) in listDataAll" :key="index">
          <div class="list-rows">
            <div class="item-label">{{ item.name }}</div>
            <div>{{ item.countWera }}</div>
          </div>
          <div class="list-rows">
            <div class="item-rows"><span>公益金比例</span><span>{{ item.allNumber }}</span></div>
            <div class="item-rows"><span>公益金</span><span>{{ item.allWera }}</span></div>
          </div>
          <div class="list-rows">
            <div class="item-rows"><span>地方公益金比例</span><span>{{ item.weraNumber }}</span></div>
            <div class="item-rows"><span>地方共礼金</span><span>{{ item.count }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.wrap {
  display: flex;
  flex-direction: column;
  background: #f8f9fd;
  min-height: calc(100vh - 92px);

  padding-top: 105px;
  box-sizing: border-box;
  .list-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    background: #fafafa;
    padding: 20px 0;
    .item-label{
      font-weight: bold;
      padding-left: 20px;
    }
    .list-rows{

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .item-rows{
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        span{
          display: block;
          padding-left: 20px;
          color: #999;
        }
      }
    }
  }

  .tab-content {
    display: flex;
    flex-direction: column;
    padding: 0 20px 20px;
    box-sizing: border-box;
    //background: red;
    .content-box {
      display: flex;
      flex-direction: column;
      //position: relative;
      //background: #e6a23c;
      .tabs-style {
        //position: absolute;
        //top: 0;
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        height: 70px;
        //position: absolute;
        //top: 190px;
        /deep/ .van-tabs {
          height: 100%;
        }

        /deep/ .van-tabs__wrap {
          height: 100%;
        }

        /deep/ .van-tabs--line {
          height: 100%;
        }

        /deep/ .van-tabs__nav {
          background: transparent;

        }

        /deep/ .van-tabs__nav--complete {
          padding-left: 0;
        }

        /deep/ .van-tab {
          margin-right: 20px;
          border-radius: 50px;
          background: #fff;
          padding: 0 30px;
          border: 2px solid #eee;
        }

        ///deep/ .van-tab:first-child {
        //  background: transparent;
        //  color: transparent;
        //  border-color: transparent;
        //  padding: 0;
        //  margin-right: 0;
        //}

        /deep/ .van-tab__text {
          font-size: 24px;
        }

        /deep/ .van-tab--active {
          border-radius: 50px;
          background: #e62d2d;
          color: #fff;

          .num-style {
            color: #fff;
            background: #c11f1f;
          }
        }

        /deep/ .van-tabs__line {
          height: 0;
        }

        .icon-style {
          font-size: 28px;
          margin-right: 5px;
        }

        .num-style {
          border-radius: 50%;
          padding: 3px 10px;
          font-size: 24px;
          color: #555;
          background: rgba(0, 0, 0, 0.1);
        }
      }

      //.choice-box{
      //position: absolute;
      //top: 80px;
      //width: 100%;
      //display: flex;
      //flex: 1;
      //flex-direction: column;
      //background: pink;
      //box-sizing: border-box;
      //height: calc(100vh - 80px - 70px );
      //overflow-y: auto;
      //.card{
      //overflow-y: auto;
      //background: red;
      //}
      //}
      .info-text {
        font-size: 24px;
        color: #666;
        background-color: #f8f9fd;
        padding: 10px;
        border-radius: 8px;
        margin-bottom: 16px;
        line-height: 1.6;
        height: 80px;

        span {
          font-weight: bold;
          font-size: 24px;
        }
      }
    }

    .carousel-settings {
      background-color: #f8f9fd;
      padding: 22px;
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;

      /deep/ .van-button {

        margin-top: 20px;
        border-radius: 16px;

      }

      /deep/ .van-button__text {
        font-size: 28px;
      }

      .input-group {
        display: flex;
        flex-direction: row;

        span {
          display: flex;
          align-items: center;
        }

        /deep/ .van-cell {
          width: 68%;
          margin: 0 8px;
        }
      }

    }

    .carousel-set {
      padding: 12px;
    }

    .publish-btn-container {
      background-color: white;
      padding: 12px 0;
      margin-top: 16px;
    }

    .publish-btn {
      width: 100%;
      padding: 20px 16px;
      background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
      color: white;
      border: none;
      border-radius: var(--radius-md);
      font-size: 28px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 12px rgba(230, 45, 45, 0.3);
    }

    .publish-btn:active {
      transform: scale(0.98);
      box-shadow: 0 2px 8px rgba(230, 45, 45, 0.3);
    }

    .info-text {
      font-size: 24px;
      color: #666;
      background-color: #f8f9fd;
      padding: 10px;
      border-radius: 8px;
      margin-bottom: 16px;
      line-height: 1.6;
      height: 80px;

      span {
        font-weight: bold;
        font-size: 24px;
      }
    }

    .playlist-card {
      background-color: white;
      border-radius: var(--radius-md);
      padding: 16px;
      margin-bottom: 16px;
      box-shadow: var(--shadow);
      border: 2px solid var(--primary-color);
    }

    .playlist-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }

    .playlist-title {
      font-size: 28px;
      font-weight: 600;
      color: var(--primary-color);
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .playlist-count {
      background-color: var(--primary-color);
      color: white;
      padding: 2px 14px;
      border-radius: 50px;
      font-size: 24px;
    }

    .playlist-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: var(--radius-sm);
      margin-bottom: 8px;
      border: 1px solid #ffe0e0;
    }

    .order-number {
      width: 38px;
      height: 38px;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: 600;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .colR {
      background-color: #e62d2d;
    }

    .colG {
      background-color: #ddd;
    }

    .remove-btn {
      width: 48px;
      height: 48px;
      background-color: #fff5f5;
      border: 1px solid #ffcccc;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 28px;
      color: #ff4444;
      margin-left: 18px;
    }

    .remove-btn:active {
      background-color: #ffe0e0;
      border-color: var(--primary-color);
    }

    .playlist-controls {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-left: auto;
      margin-right: 8px;
    }

    .order-btn {
      width: 48px;
      height: 48px;
      background-color: white;
      border: 1px solid var(--border-color);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 18px;
      color: var(--text-secondary);
    }

    .order-btn:active {
      background-color: var(--secondary-color);
      border-color: var(--primary-color);
      color: var(--primary-color);
    }

    .order-btn-disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }


    .duration-edit {
      display: flex;
      align-items: center;
      gap: 4px;

      .time-text {
        width: 40%;
        margin: 0 10px;
      }
    }

    .duration-edit input {
      width: 120px;
      padding: 4px 10px;
      border: 1px solid var(--border-color);
      border-radius: 4px;
      font-size: 22px;
      text-align: center;
    }

    .duration-edit span {
      font-size: 26px;
      color: var(--text-secondary);
    }

    .material-list {
      margin-top: 12px;
    }

    .material-list-auto {
      margin-top: 12px;
    }

    .material-icon-evolve {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
    }

    .m-a-t {
      display: flex;
      flex-direction: row;
    }

    .edit-evolve {
      display: inline-block;
      padding: 5px 15px;
      margin-left: 10px;
      background-color: #f0f4ff;
      border: 2px solid #667eea;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 34px;
      color: #667eea;
    }

    .del-evolve {
      padding: 5px 15px;
      margin-left: 10px;
      background-color: #fff5f5;
      border: 2px solid #f44336;
      border-radius: 12px;
      display: inline-block;
      transition: all 0.2s;
      font-size: 34px;
      color: #f44336;
    }

    .pending-icon {
      background-color: #fff3e0;
      color: #ff9800;
    }

    .failed-icon {
      background-color: #ffebee;
      color: #f44336;
    }

    .status-evolve {
      display: inline-flex;
      padding: 3px 10px;
      border-radius: 12px;
      font-weight: 500;
      align-items: center;
      gap: 4px;
    }

    .material-item-auto {
      background: #f8f9fd;
      display: flex;
      align-items: center;
      padding: 12px 12px 12px 4px;
      border-radius: var(--radius-sm);
      margin-bottom: 8px;
    }

    .Pass {
      border-left: 6px solid #667eea;
    }

    .Pending {
      border-left: 6px solid #ff9800;
    }

    .Failed {
      border-left: 6px solid #f44336;
    }

    .material-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: var(--radius-sm);
      margin-bottom: 8px;
    }

    .material-icon {
      width: 60px;
      height: 60px;
      background-color: #e0e0e0;
      border-radius: var(--radius-sm);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 42px;
      margin-left: 12px;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .material-icon-auto {
      width: 60px;
      height: 60px;
      background-color: #e0e0e0;
      border-radius: var(--radius-sm);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 42px;
      margin-left: 8px;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .material-info {
      flex: 1;
      padding: 0 20px;
    }

    .material-info-auto {
      flex: 1;
      padding: 0 0 0 10px;
    }

    .material-name-auto {
      font-size: 28px;
      font-weight: 500;
      margin-bottom: 4px;
      word-break: break-word;

      span {
        padding: 4px;
        font-size: 22px;
      }

      //.gGeneral{
      //  background-color: #e3f2fd;
      //  color: #1976d2;
      //}
      //.pPersonal{
      //  background-color: #e3f2fd;
      //  color: #1976d2;
      //}
    }

    .material-name {
      font-size: 28px;
      font-weight: 500;
      margin-bottom: 4px;
      word-break: break-word;

      span {
        padding: 4px;
        font-size: 22px;
      }

      .gGeneral {
        background-color: #e3f2fd;
        color: #1976d2;
      }

      .pPersonal {
        background-color: #fff2fd;
        color: #ff9800;
      }
    }

    .material-meta {
      font-size: 24px;
      color: #666;

      span {

        font-size: 24px;
      }
    }

    .material-switch {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      margin-left: 12px;
    }

    .material-switch-auto {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      margin-left: 12px;
    }

    .material-switch-label {
      font-size: 22px;
      color: #666;
    }

    .empty-state {
      text-align: center;
      padding: 60px 20px;
      color: var(--text-light);
    }

    .empty-icon {
      font-size: 68px;
      margin-bottom: 12px;
    }

    .empty-text {
      font-size: 24px;
    }

    .check-item {
      background-color: #fff5f5;
    }

    .new-item {
      background-color: #f8f9fd;

    }

    .new-item-auto {
      //background-color: #f8f9fd;

    }
  }

}

.switch-item-box {
  display: flex;
  flex-direction: row;

  .switch-label {
    display: flex;
    font-size: 26px;
    margin-bottom: 50px;
    //color: var(--text-color);
  }

  span {
    display: flex;
    align-items: center;
    padding-left: 20px;
  }
}

.switch-line {
  padding: 0 20px 0 10px;
  display: flex;
  flex-direction: row;

  .line-box {
    width: 70%;
  }

  .line-number {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      color: var(--primary-color);
      font-size: 30px;
      font-weight: bold;
      padding-right: 10px;
    }
  }
}

.switch-item-tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;

  .switch-label {
    display: flex;
    font-size: 26px;
    //color: var(--text-color);
  }
}

.line {
  border-bottom: 2px solid #eee;
}

.switch-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;

  .switch {
    display: flex;

    .van-switch {
      background: #4caf50;
    }
  }

  .switch-label {
    display: flex;
    font-size: 26px;
    //color: var(--text-color);
  }

  .switch-desc {
    display: flex;
    font-size: 24px;
    //color: var(--text-secondary);
    margin-top: 4px;
  }
}

.switch-item:last-child {
  border-bottom: none;
}

///deep/.van-switch{
//  width: 1.6em;
//}
///deep/.van-switch__node{
//  height: 1.3em;
//  width: 1.3em;
//  left: 4px;
//  top: 4px;
//}

.schedule-section {
  margin-top: 16px;
  padding: 16px 0 0 0;

  .subsection-title {
    padding-bottom: 16px;
  }

  .list-btn {
    padding-top: 20px;

    /deep/ .van-button {
      width: 100%;
      border-radius: 16px;
    }

    /deep/ .van-button__text {
      font-size: 28px;
    }
  }
}

.schedule-item {
  background-color: #f8f9fd;
  border-radius: 8px;
  padding: 12px 20px;
  margin-bottom: 18px;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.schedule-title {
  font-size: 24px;
  font-weight: 500;
  color: var(--text-color);
}

.time-picker-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.time-picker {
  flex: 1;
}

.time-label {
  font-size: 26px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.time-input {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 26px;
  color: var(--text-color);
}

/deep/ .van-cell {
  padding: 14px 14px;
  font-size: 24px;
  border: 2px solid #eee;
  border-radius: 12px;
}

/deep/ .van-field__control:read-only {
  font-size: 24px;
}

.inner-diag {
  padding: 30px 30px 0;
  box-sizing: border-box;
  border-radius: 30px;
  display: flex;
  flex-direction: column;

  //----


  //-----
  .fixed-close {
    position: absolute;
    right: 50px;
    top: 1px;
    font-size: 50px;
    color: #999;
  }

  .upload-requirements {
    padding: 12px;
    background: linear-gradient(135deg, #f0f4ff, #f8f9ff);
    border-radius: var(--radius-sm);
    border-left: 3px solid #667eea;
    margin-bottom: 16px;

    .req-title {
      font-size: 26px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }

  .form-commit {
    font-size: 24px;
    margin-bottom: 20px;

    /deep/ .van-cell {
      font-size: 24px;

    }

    /deep/ .van-field__control {
      font-size: 24px;

    }
  }


  .inner-title {
    display: flex;
    font-weight: bold;
    justify-content: center;
    font-size: 36px;
    padding-top: 60px;
    box-sizing: border-box;
  }

  .inner-txt {
    display: flex;
    justify-content: center;
    color: #666;
    padding-top: 30px;
    box-sizing: border-box;
  }

  .inner-btn {
    display: flex;
    justify-content: space-between;
    padding: 50px 40px 0;

    .block-btn {
      width: 46%;

      /deep/ .van-button__text {
        font-size: 28px;
      }
    }

    .font {
      background: #f5f6fa;

      /deep/ .van-button__text {
        color: #666;
        font-size: 28px;
      }
    }
  }
}

/deep/ .el-slider__runway {
  height: 0.28rem;
  border-radius: 10px;
}

/deep/ .el-slider__button {
  height: 0.6rem;
  width: 0.6rem;
  background: var(--primary-color);
  border: 0.08rem solid #fff;
}

/deep/ .el-slider__bar {
  height: 0.28rem;
  border-radius: 10px;
  background: var(--primary-color);

}

.upload-submit {
  display: flex;
  background: #f8f9fd;
  padding: 20px;
  flex-flow: column;
}

.group-video {
  //border: 1px dashed #afafaf;
  border-radius: 10px;
  //height: 37vw;
  //width: 37vw;
  //background: #2196f3;
  margin-top: 20px;
  position: relative;

  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 200px;
    width: 200px;
    border: 2px dashed #e9e9e9;
    overflow: hidden;

    .upload-area {
      border-radius: 12px;
      padding: 40px 20px;
      text-align: center;
      background: transparent;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      /* 实现水平方向上居中 */
      justify-content: center;
      /* 实现垂直方向居中 */
      align-items: center;

      .file-input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;
        background: transparent;
      }

      .icon-calm {
        position: absolute;
        width: 60px;
        height: 60px;
        font-size: 46px;
        color: #ddd;
      }
    }

    //.avatar-uploader{
    //  display: flex;
    //  width:100%;
    //  height:100%;
    //  align-items: center;
    //  justify-content: center;
    //  overflow: hidden;
    //  .el-upload{
    //    width:100%;
    //    height:100%;
    //    .avatar{
    //      width:100%;
    //      height:100%;
    //      img{
    //        width:100%;
    //        height:100%;
    //      }
    //    }
    //  }
    //}
    /deep/ .van-uploader {
      width: 100%;
      height: 100%;
      overflow: hidden;

    }

    /deep/ .van-uploader__wrapper {
      width: 100% !important;
      height: 100% !important;

    }

    /deep/ .van-uploader__preview {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    /deep/ .van-uploader__preview-image {
      width: 100% !important;
      height: 100% !important;
    }

    /deep/ .van-uploader__upload {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    /deep/ .van-uploader__file {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    .post-video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      overflow: hidden;

      video {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }

    .group-load-item {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      padding: 70px 0;
      text-align: center;
      width: 100%;
      height: 100%;
      font-size: 28px;

      .video-icon-img {
        width: 80px;
        height: 50px;
        margin: 0 auto;
        font-size: 60px;
        color: #ababab;

        img {
          width: 80px;
          height: 50px;
        }
      }

      .video-icon-txt {
        color: #ababab;
        padding-top: 20px;
      }
    }

    .aod {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10000;
      color: #fff;
      font-size: 30px;
      height: 44px;
      line-height: 44px;
      width: 44px;
      text-align: center;
      background: #222;
      border-radius: 0 12px 0 0.32rem;
    }
  }
}

  .filter-section {
    border-radius: var(--radius-md);
    padding: 12px;
    margin-bottom: 16px;

    .filter-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      align-items: flex-end;

      .filter-group {
        display: flex;
        flex-direction: column;

        .filter-label {
          color: var(--text-secondary);
          margin-bottom: 6px;
          font-weight: 500;
        }

        .filter-select {
          padding: 8px 12px;
          border: 1px solid var(--border-color);
          border-radius: var(--radius-sm);
          color: var(--text-color);
          background-color: white;
          cursor: pointer;
          transition: all 0.2s;
        }
      }
    }
  }

//.van-uploader{
//  width:100%;
//  height:100%;
//  top:0;
//  z-index:2;
//  /deep/.van-uploader__wrapper{
//    width:100% !important;
//    height:100% !important;
//  }
//  /deep/.van-uploader__upload{
//    position: absolute;
//    top: 0;
//    width:100% !important;
//    height:180px !important;
//    background: transparent;
//    margin: 5px;
//    //.van-icon{
//    //  display: none;
//    //}
//  }
//  /deep/.van-uploader__preview{
//    width: 100%;
//    height: 100%;
//    margin: 0;
//    .van-uploader__mask{
//      opacity: 0.5;
//      .van-uploader__loading{
//        .van-loading__spinner{
//          display:block;
//        }
//      }
//      .van-uploader__mask-icon{
//        color: red;
//        font-size: 80px;
//      }
//    }
//  }
//  /deep/.van-uploader__preview-image{
//    width: 100%;
//    height: 100%;
//
//  }
//  // /deep/.van-uploader__preview-image img{
//  //     object-fit:cover;//contain
//  // }
//}

/deep/ .van-uploader__preview-delete {
  height: 48px !important;
  width: 48px !important;
  z-index: 5;
}

/deep/ .van-uploader__preview-delete-icon {
  top: -8px !important;
  right: -8px !important;
  font-size: 60px !important;
}

/deep/ .van-uploader__file-name {
  color: transparent;
}

.progress-container {
  margin-top: 20px;
  display: none;
}

.progress-container.active {
  display: block;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  color: #2c3e50;
}

.progress-bar {
  height: 10px;
  background: #ecf0f1;
  border-radius: 5px;
  overflow: hidden;

  .progress-fill {
    height: 100%;
    background: #2ecc71;
    width: 0;
    transition: width 0.3s ease;
  }
}
</style>